import { ApiResponse } from "../common/type";
import axiosClient from "./axiosClient";

const bankApi = {
    getAllBank: async (): Promise<ApiResponse<any>> => {
        return axiosClient.get('/banks');
    },
};

export default bankApi;
